export const CONSENT_STORAGE_KEY = 'ollaa_consent_v1';
export const CONSENT_VERSION = 1;

export const CONSENT_FEATURES = {
  analytics: false,
};

export function isConsentUiEnabled() {
  return CONSENT_FEATURES.analytics === true;
}

export const CONSENT_COPY = {
  bannerTitle: 'Hinweis zu Cookies & Speicher',
  bannerText:
    'Ollaa Partner verwendet ausschließlich technisch notwendige Speicher '
    + '(z. B. für Login, Sicherheit und App-Funktionen). '
    + 'Es werden keine Analyse- oder Marketing-Cookies eingesetzt.',
  acknowledge: 'Verstanden',
  privacyLink: 'Datenschutzerklärung',
  settingsTitle: 'Datenschutz-Einstellungen',
  necessaryTitle: 'Technisch notwendig',
  necessaryDescription:
    'Erforderlich für Login, Sicherheit und grundlegende App-Funktionen. Diese Speicher können nicht deaktiviert werden.',
};
